<!--
 * @Author: your name
 * @Date: 2020-06-29 16:10:51
 * @LastEditTime: 2020-08-10 15:01:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\Index\Index.vue
--> 
<template>
  <div class="warrantyRecord-wrap"
    v-loading="loading"
    element-loading-text="正在查询您的报修记录，请稍等">
    <div v-if="RecordFlag">
      <div class="warrantyRecord-back"></div>
      <div class="warrantyRecord-content">
        <div v-for="item in warrantyRecord" :key="item.id" @click="getwarrantyInfo(item)" class="warrantyRecord-content-assigned">
          <div style="display: flex;justify-content: space-between;">
            <div style="padding-left: 0.2rem;">
              <div :class="{activeType1: item.maintain_type_id == 1, activeType2: item.maintain_type_id == 2}">{{item.maintain_type}}</div>
              <div style="margin-top: 0.05rem;">工单编号：{{item.work_order_Number}}</div>
            </div>
            <div>
              <div class="box" :style="{color:item.color,background:item.background_color,borderBottom:item.boderStyle}">{{item.status_name}}</div>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;padding:0.05rem 0.1rem 0.2rem 0.2rem">
            <div>{{item.maintain_content | textFilter}}</div>
            <div>{{item.submit_time}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="margin-top:0.5rem;"><img src="../../../assets/image/recordfail.png" alt="" style="margin:0 auto"></div>
      <div style="color: #007B83;text-align:center;margin-top:0.2rem;">暂无报修记录</div>
      <div style="text-align:center;margin-top:0.5rem;">
        <el-button style="background: #007B83;color:#fff;width:2.7rem;border:none;padding:4%;" @click="goWarranty">去报修</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'warrantyRecord',
  data(){
    return{
      imgIndexOf:1,// 图标索引
      warrantyRecord:[],// 该用户的报修记录
      loading:true,
      RecordFlag:true,// true有记录 false无记录
    }
  },

  methods:{
    // 获取用户的报修记录
    async getWarrantyRecord(){
      const res = await this.$http.get(`${this.$url.globalurl}/wxWarranty`);
      if(res.result.length >0){
        const orderNumber = '000000';
        res.result.forEach(i=>{
          i.submit_time = moment(i.submit_time).format('YYYY-MM-DD HH:mm');
          i.boderStyle = 'solid 1px ' + i.color;
          i.work_order_Number = moment().format('YYYYMMDD') + orderNumber.slice(0,-i.work_order_id.length) + i.work_order_id;
        })
        this.warrantyRecord =  res.result;
        this.RecordFlag = true;
        this.loading = false;
      }else{
        this.RecordFlag = false;
        this.loading = false;
      }
    },
    // 查看工单的详情信息
    async getwarrantyInfo(item){
      const workOrderId = item.work_order_id;
      const color = item.color;
      const backgroundColor = item.background_color;
      const statusName = item.status_name;
      this.$router.push({
        name:'warrantyInfo',
        query:{
          workOrderId,
          color,
          backgroundColor,
          statusName
        }
      });
    },
    goWarranty(){
      this.$router.push({
        name:'warranty'
      })
    }
  },

  mounted(){
    this.getWarrantyRecord();
    document.title = '报修记录';
  },
  filters:{
    textFilter:function(text){
      if(!text) return;
      text = text;
      if(text.length > 15){
        return text.substring(0,15) + '...';
      }else{
        return text;
      }
    }
  }
}
</script>
<style lang='scss' scoped>
@import url(warrantyRecord.scss);
</style>
